// src/components/meetings/MeetingEmbed.js

import React from 'react';
import styles from './MeetingEmbed.module.css';

const MeetingEmbed = ({ joinURL }) => {
    if (!joinURL) {
        return <p>Meeting URL is not available.</p>;
    }

    // You might need to adjust the URL to make it embeddable,
    // although the default joinURL usually works.
    const embedURL = joinURL; // Assuming the joinURL is already embeddable
    
    return (
        <div className={styles.embedContainer}>
            <iframe
                src={embedURL}
                title="Zoho Meeting"
                allow="camera; microphone; fullscreen; display-capture"
                allowFullScreen
                className={styles.meetingFrame}
            />
        </div>
    );
};

export default MeetingEmbed;